import formatDateShort from '@utilities/formatDate'
import getEasternTimezone from '@utilities/functions/getEasternTimezone'

const LastUpdated = ({ lastUpdated }: { lastUpdated: Date }) => {
  return (
    <div
      className="flex gap-2 sm:gap-1 md:gap-2 text-bidfta-blue-dark my-4 tracking-tight sm:tracking-tighter md:tracking-tight text-12 sm:text-14"
      style={{ minWidth: '14rem' }}
    >
      <h4 className="font-bold uppercase ">Last Update:</h4>
      <span className="font-semibold">
        {formatDateShort(getEasternTimezone(lastUpdated))} EST
      </span>
    </div>
  )
}

export default LastUpdated
